import React from 'react'
import { useMemo } from 'react'
import style from './EquipmentCarbon.module.css'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ScrollArrow } from '../../../Components/ScrollArrow/ScrollArrow'
import Breadcrumbs from '../../../Components/Breadcrumbs/Breadcrumbs'

const EquipmentCarbon = () => {
  const { t } = useTranslation()

  const breadcrumbItems = useMemo(
    () => [
      { path: '/', label: t('breadcrumbs.home') },
      { path: '/engineering', label: t('breadcrumbs.engineering') },
      // { path: '/engineering/carbon-fiber', label: t('breadcrumbs.carbon_fiber_equipment') },
    ],
    [t],
  )
  return (
    <div className={style.engineering} id={'carbon'}>
      <div className={`${'customContainer'} ${style.engineering_wrap}`}>
        <Breadcrumbs items={breadcrumbItems} />
        <h2 className={style.title}>{t('equipmentCarbon.title')}</h2>
        <p className={style.desc}>{t('equipmentCarbon.desc')}</p>
        <Link to={'/engineering/carbon-fiber'} className={style.button}>
          {t('engineering.button')}
        </Link>
        <div className={style.block_arrow}>
          <ScrollArrow />
        </div>
      </div>
    </div>
  )
}

export default EquipmentCarbon
